import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ICriteriaRating, IPosition, IServiceType } from './interfaces';

export const getCriteriaRatingList = (data: IDynamicTableParams) => {
  return instance()
    .post<ICriteriaRating[]>(`/criteriaRating/list`, data)
    .then((response) => response.data);
};

export const getCriteriaRatingAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>(`/criteriaRating/availableColumns`)
    .then((response) => response.data);
};

export const getCriteriaRatingAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>(`/criteriaRating/availableGroupColumns`)
    .then((response) => response.data);
};

export const loadCriteriaRating = (criteriaRatingId: number) => {
  return instance()
    .get<ICriteriaRating>(`/criteriaRating/${criteriaRatingId}/load/`)
    .then((response) => response.data);
};

export const createCriteriaRating = (criteriaRating: ICriteriaRating) => {
  return instance()
    .post<ICriteriaRating>('/criteriaRating/save', criteriaRating)
    .then((response) => response.data);
};

export const updateCriteriaRating = (criteriaRating: ICriteriaRating) => {
  return instance()
    .post<ICriteriaRating>(`/criteriaRating/${criteriaRating.criteriaRatingId}/update`, criteriaRating)
    .then((response) => response.data);
};

export const archiveCriteriaRating = (criteriaRatingId: number) => {
  return instance()
    .post('/criteriaRating/archive', { criteriaRatingId })
    .then((response) => response.data);
};

export const recoverCriteriaRating = (criteriaRatingId: number) => {
  return instance()
    .post('/criteriaRating/recover', { criteriaRatingId })
    .then((response) => response.data);
};

export const getServiceTypeListAllNotDeleted = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IServiceType[]>(`/serviceType/listAllNotDeleted`, config)
    .then((response) => response.data);
};

export const getPositions = (config?: AxiosRequestConfig) => {
  return instance()
    .post<IPosition[]>(`/dictionary/positions`, {}, config)
    .then((response) => response.data);
};
